import "core-js/modules/es.string.trim-start.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { useState } from 'react';
import { toast } from 'react-toastify';
import { BiMailSend } from 'react-icons/bi';
import Page from '../components/Page';
import SEO from '../components/SEO';
import { FlexContainer, Form, MailIcon, FormGroup, Input, TextArea, Label, Button, ToastMessage } from '../styles';
var encode = function encode(data) {
    return Object.keys(data).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');
};
export default (function () {
    var _useState = useState({
        name: '',
        email: '',
        message: ''
    }), contactMessage = _useState[0], setContactMessage = _useState[1];
    var handleChange = function handleChange(e) {
        var _e$target = e.target, name = _e$target.name, value = _e$target.value;
        setContactMessage(function (prevState) {
            var _Object$assign;
            return Object.assign({}, prevState, (_Object$assign = {}, _Object$assign[name] = value.trimLeft(), _Object$assign));
        });
    };
    var handleSubmit = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(e) {
            var response;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            e.preventDefault();
                            _context.next = 3;
                            return fetch('/', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                },
                                body: encode(Object.assign({
                                    'form-name': 'contact'
                                }, contactMessage))
                            });
                        case 3:
                            response = _context.sent;
                            if (response.ok) {
                                toast.success(/*#__PURE__*/ _jsxs(ToastMessage, {
                                    children: [/*#__PURE__*/ _jsx("p", {
                                            children: "\uD83D\uDE00"
                                        }), /*#__PURE__*/ _jsx("p", {
                                            children: "Thank you for your message, I will get back to you shortly."
                                        })]
                                }), {
                                    position: 'bottom-center',
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    pauseOnHover: true,
                                    draggable: false
                                });
                            }
                            else {
                                toast.error(/*#__PURE__*/ _jsxs(ToastMessage, {
                                    children: [/*#__PURE__*/ _jsx("p", {
                                            children: "\uD83D\uDE25"
                                        }), /*#__PURE__*/ _jsx("p", {
                                            children: "An error has occured, please try again later."
                                        })]
                                }), {
                                    position: 'bottom-center',
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    pauseOnHover: true,
                                    draggable: false
                                });
                            }
                            setContactMessage({
                                name: '',
                                email: '',
                                message: ''
                            });
                        case 6:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee);
        }));
        return function handleSubmit(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(Page, {
        title: "Contact",
        subTitle: "Get in touch if you like what you have seen",
        children: [/*#__PURE__*/ _jsx(SEO, {
                title: "Contact"
            }), /*#__PURE__*/ _jsxs(Form, {
                onSubmit: handleSubmit,
                children: [/*#__PURE__*/ _jsx(MailIcon, {
                        children: /*#__PURE__*/ _jsx(BiMailSend, {})
                    }), /*#__PURE__*/ _jsxs(FormGroup, {
                        children: [/*#__PURE__*/ _jsx(Input, {
                                type: "text",
                                name: "name",
                                value: contactMessage.name,
                                onChange: handleChange,
                                required: true
                            }), /*#__PURE__*/ _jsx(Label, {
                                children: "Name"
                            })]
                    }), /*#__PURE__*/ _jsxs(FormGroup, {
                        children: [/*#__PURE__*/ _jsx(Input, {
                                type: "email",
                                name: "email",
                                value: contactMessage.email,
                                onChange: handleChange,
                                required: true
                            }), /*#__PURE__*/ _jsx(Label, {
                                children: "Email"
                            })]
                    }), /*#__PURE__*/ _jsxs(FormGroup, {
                        children: [/*#__PURE__*/ _jsx(TextArea, {
                                rows: 8,
                                name: "message",
                                value: contactMessage.message,
                                onChange: handleChange,
                                required: true
                            }), /*#__PURE__*/ _jsx(Label, {
                                children: "Message"
                            })]
                    }), /*#__PURE__*/ _jsx(FlexContainer, {
                        w: "100%",
                        p: 0,
                        justifyContent: "center",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            children: "Submit"
                        })
                    })]
            })]
    });
});
